export function isNavigationItemActive(pathname: string, target: string) {
  const normalizedPathname =
    pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const normalizedTarget =
    target.length > 1 ? target.replace(/\/+$/, "") : target;

  return (
    normalizedPathname === normalizedTarget ||
    normalizedPathname.startsWith(`${normalizedTarget}/`)
  );
}
